interface StartCaseOptions {
  doctor_id?: number;
  lang?: string;
  insurance?: string;
  [key: string]: string | number | undefined;
}

export const getStartCaseURL = (
  tenantId: string,
  options?: StartCaseOptions
) => {
  const queryOptions = !options
    ? ""
    : Object.keys(options)
        .filter((key) => options[key] !== "")
        .map((key) => `${key}=${options[key]}`)
        .join("&");

  return new URL(
    `/t/${tenantId}/case?${queryOptions}`,
    process.env.patientAccessUiBaseUrl
  );
};

export const stringFromQueryParam = (param?: string | string[]) =>
  typeof param === "string" ? param : undefined;

export const publicAssetUrl = (path: string) =>
  process.env.NEXT_PUBLIC_PUBLIC_ASSET_CDN
    ? `${process.env.NEXT_PUBLIC_PUBLIC_ASSET_CDN}${path}`
    : path;
